import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import Snackbar, {
  SnackbarOrigin,
  SnackbarProps,
} from '@mui/material/Snackbar';
import Button from '../Button';
import breakpoints from '../Theme/breakpoints';

interface SnackbarProperties extends SnackbarProps {
  actionWidth?: string;
  anchorOrigin?: SnackbarOrigin;
}

const withActionWidth = ({ actionWidth }: SnackbarProperties) => css`
  .MuiSnackbarContent-root {
    display: grid;

    grid-template-columns: auto;
    grid-template-rows: 1fr 40px;
    @media (min-width: ${breakpoints.sm}px) {
      grid-template-columns: 1fr ${actionWidth};
      grid-template-rows: auto;
    }
  }

  .MuiSnackbarContent-action {
    & * {
      flex-grow: 1;
    }

    flex-direction: row;
    margin: 0;

    padding-left: 0;
    @media (min-width: ${breakpoints.sm}px) {
      padding-left: 16px;
    }

  }
`;

const StyledSnackbar = styled((
  { actionWidth, ...properties }: SnackbarProperties,
) => (
  <Snackbar
    {...properties}
  />
))`
  &&& {
    z-index: 99999;

    @media (min-width: ${breakpoints.sm}px) {
      min-width: 300px;
    }

    p {
      font-size: var(--size-sub2);
      line-height: 1rem;

      @media (min-width: ${breakpoints.sm}px) {
        font-size: var(--size-sub1);
        line-height: 1.25rem;
      }
    }

    @media (min-width: ${breakpoints.xssm}px) {
      min-width: 400px;
    }
  }

  .MuiSnackbarContent-message {
    padding: 0;
  }

  ${({ actionWidth }) => actionWidth && withActionWidth};
`;

export const SnackbarButton = styled(Button)`
  && {
    height: unset;
    min-height: 40px;
    min-width: 80px;
    font-size: var(--size-caption);
  }
`;

const MuiSnackbar = (properties : SnackbarProperties) => (
  <StyledSnackbar
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    {...properties}
  />
);

export const SnackbarContent = styled.div`
  display: flex;
  align-items: center;
`;

export default MuiSnackbar;
